<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="management"
    v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important',
      'background-attachment': 'fixed',
      overflow: 'scroll'
    }"
  >
    <img
      v-if="ingresoLogo"
      :src="ingresoLogo.imagen"
      id="logo"
      v-bind:style="logoStyle"
      alt="logo"
    />
    <b-card class="bg-card-grey" v-if="fileOnFlow.ejecucion">
      <div class="row">
        <div class="col-1 position-relative text-center">
          <div v-if="fileOnFlow.documentos.length" class="container-attachment">
            <div
              class="box-attachments"
              v-for="attachment in fileOnFlow.documentos"
              :key="attachment.adjuntoUrl"
            >
              <b-button
                variant="outline-warning"
                class="btn-icon mt-2 text-center shadow"
                @click="selectFile(attachment)"
                data-cy="attachment"
              >
                <feather-icon icon="FileTextIcon" />
              </b-button>
            </div>
            <div
              class="position-fixed manage-comments text-left m-auto"
              v-if="isAvailableSign"
            >
              <h6 style="font-size: 12px;" class="my-2">
                Hey, estampa!!
              </h6>
              <b-button
                ref="signPosition"
                variant="warning"
                class="btn-icon rounded-circle shadow-lg sign-file"
                @click="setSign"
                data-cy="stamp"
              >
                <feather-icon icon="FeatherIcon" />
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-7">
          <a
            :href="selectedFile.adjuntoUrl"
            v-if="selectedFile"
            target="_blank"
          >
            <h5
              class="text-primary underline d-inline-block mr-2"
              data-cy="document-viewer"
            >
              * Visualizando documento seleccionado {{selectedFile.objetoNombre}}
              <small>({{selectedFile.objetoNombre}})</small> *
            </h5>
            <feather-icon icon="ExternalLinkIcon" />
          </a>
          <div v-if="selectedFile" class="shadow bg-gray">
            <div v-if="fileType === 'pdf'" class="d-flex">
              <PdfViewport
                ref="pdfSignaturePerson"
                :s3url="selectedFile.adjuntoUrl"
                :name="selectedFile.objetoNombre"
                :signatures="signatures"
                :signature-height="signatureHeight"
                :signature-width="signatureWidth"
                @signature-drag-end="onSignatureDragEnd"
                @loaded="setSign"
                @signature-delete="closeSign"
                :closable="false"
              />
            </div>
            <div v-if="fileType === 'image'">
              <b-img :src="selectedFile.adjuntoUrl" fluid :alt="selectedFile.objetoNombre" />
            </div>
          </div>
        </div>
        <div class="col-4">
          <b-card class="shadow border-1 pt-0">
            <div class="bg-white pb-2">
              <h5 class="card-title mb-0" v-if="fileOnFlow.ejecucion">
                Expediente # {{fileOnFlow.ejecucion.numero}} en el
                {{fileOnFlow.ejecucion.nombre}}
              </h5>
              <div class="text-primary">
                {{fileOnFlow.ejecucion.descripcion}}
              </div>
            </div>
            <b-card-body class="p-0">
              <div class="mt-2 shadow">
                <Steps
                  v-if="fileOnFlow.pasos"
                  :steps="stepsFile"
                  :ejecucion="fileOnFlow.ejecucion"
                />
              </div>
              <div class="mt-5" v-if="isAvailableSign">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-success"
                  data-cy="sign"
                  block
                  @click="confirmSignFile()"
                >
                  Firmar
                </b-button>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </b-card>

    <!-- Modal OTP -->
    <b-modal
      v-model="showOtpModal"
      title="Verificación de firma"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      @hidden="resetOtp"
    >
      <div class="text-center">
        <feather-icon icon="MailIcon" size="48" class="text-primary mb-1" />
        <p class="mb-2">
          Se enviará un código de verificación al correo electrónico registrado.
          Ingresa el código para confirmar tu firma.
        </p>

        <div v-if="!otpSent" class="mb-2">
          <b-button
            variant="primary"
            :disabled="otpLoading"
            @click="requestOtp"
            data-cy="request-otp"
          >
            <b-spinner v-if="otpLoading" small class="mr-1" />
            Enviar código
          </b-button>
        </div>

        <div v-if="otpSent">
          <div class="mb-1">
            <label class="d-block text-center font-weight-bold mt-2 mb-1">Código OTP</label>
            <OtpInput
              ref="otpInput"
              v-model="otpCode"
              :disabled="otpLoading"
              :has-error="!!otpError"
              @complete="signFileWithOtp"
            />
            <small v-if="otpError" class="text-danger d-block mt-50">
              {{ otpError }}
            </small>
          </div>

          <div class="mt-1 mb-1">
            <small v-if="otpCountdown > 0" class="text-muted">
              Puedes solicitar un nuevo código en {{ otpCountdown }}s
            </small>
            <b-button
              v-else
              variant="link"
              size="sm"
              :disabled="otpLoading"
              @click="requestOtp"
              data-cy="resend-otp"
            >
              Reenviar código
            </b-button>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <b-button
          variant="outline-secondary"
          :disabled="otpLoading"
          @click="showOtpModal = false"
        >
          Cancelar
        </b-button>
        <b-button
          v-if="otpSent"
          variant="success"
          :disabled="!otpCode || otpLoading"
          @click="signFileWithOtp"
          data-cy="confirm-otp"
        >
          <b-spinner v-if="otpLoading" small class="mr-1" />
          Confirmar firma
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { uuid } from 'vue-uuid';

import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import OtpInput from '@/components/inputs/OtpInput';
import { SIGNATURE_TYPES } from '@/febos/global/pdf/config';
import ApprovalProcessStates from '@/febos/chile/approvals/mixins/ApprovalProcessStates';

const SIGNATURE_WIDTH = 150;
const SIGNATURE_HEIGHT = 50;

export default {
  mixins: [PersonalizacionMixin],
  components: {
    PdfViewport,
    Steps,
    OtpInput
  },
  data() {
    return {
      signatures: [{ x: 198, y: 119 }],
      selectedFile: undefined,
      fileType: undefined,
      showSignButton: false,
      signatureWidth: SIGNATURE_WIDTH,
      signatureHeight: SIGNATURE_HEIGHT,
      flowStates: ApprovalProcessStates,
      // OTP
      showOtpModal: false,
      otpSent: false,
      otpCode: '',
      otpId: null,
      otpCountdown: 0,
      otpTimer: null,
      otpLoading: false,
      otpError: null
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#management > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#management',
        scale: 0.6
      });
    }
  },
  computed: {
    ...mapGetters('Personalizacion', [
      'colors',
      'empresaPortal'
    ]),
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow'
    ]),
    token() {
      const { token } = this.$route.params;
      return token;
    },
    currentStep() {
      const {
        pasos = [],
        ejecucion
      } = this.fileOnFlow;
      return pasos.find((step) => step.id === ejecucion.pasoActualId);
    },
    hasSignaturePosition() {
      return (
        this.currentStep.x
        && this.currentStep.y
        && this.currentStep.pagina
      );
    },
    stepsFile() {
      return [this.fileOnFlow.pasoActual];
    },
    isAvailableSign() {
      const { pasoActual } = this.fileOnFlow;
      return pasoActual.aprobacionesPasoEstadoId === this.flowStates.PROCESSING;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalFileSignaturePerson',
      'singPersonFile',
      'requestSignatureOtp'
    ]),
    selectFile(file) {
      this.signatures = [];
      this.selectedFile = undefined;
      this.fileType = undefined;

      const fileName = file.objetoNombre.toLowerCase();

      if (file && (fileName.includes('png')
        || fileName.includes('jpg')
        || fileName.includes('jpeg')
      )) {
        this.fileType = 'image';
        this.selectedFile = file;
      }

      if (file && fileName.includes('pdf')) {
        this.fileType = 'pdf';
        this.selectedFile = file;

        this.showSignButton = !file.objetoId;
        return;
      }

      this.$bvToast.toast(
        'Este tipo de archivo no puede ser visualizado',
        {
          title: '¡Oops!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      window.open(file.url, '_blank');
    },
    onSignatureDragEnd({ x, y }, signatureDraged) {
      const [signature] = this.signatures.filter(
        (signatureItem) => signatureItem.signatureId === signatureDraged.signatureId
      );
      this.signatures = [
        {
          ...signature,
          x,
          y
        }, ...this.signatures.filter(
          (signatureItem) => signatureItem.signatureId !== signatureDraged.signatureId
        )
      ];
    },
    setSign() {
      if (!this.isAvailableSign) {
        this.signatures = [];
        return;
      }
      if (this.hasSignaturePosition) {
        const {
          x,
          y,
          pagina: page
        } = this.currentStep;
        const { pasoActual } = this.fileOnFlow;
        const signatureId = uuid.v4();
        this.signatures = [{
          id: signatureId,
          x,
          y,
          page,
          type: SIGNATURE_TYPES.PersonSignature,
          name: pasoActual.paso.responsable
        }];
      } else {
        const pageNumber = this.$refs.pdfSignaturePerson.getPageNumber();
        const pageHeight = this.$refs.pdfSignaturePerson.getPageHeight();
        const signatureId = uuid.v4();
        this.signatures = [{
          signatureId,
          x: 20,
          y: pageHeight - 70,
          page: pageNumber,
          type: SIGNATURE_TYPES.DraggableUserSignature
        }];
      }
    },
    closeSign() {
      this.signatures = [];
    },
    confirmSignFile() {
      this.showOtpModal = true;
    },
    startOtpCountdown() {
      this.otpCountdown = 30;
      clearInterval(this.otpTimer);
      this.otpTimer = setInterval(() => {
        this.otpCountdown -= 1;
        if (this.otpCountdown <= 0) {
          clearInterval(this.otpTimer);
          this.otpTimer = null;
        }
      }, 1000);
    },
    async requestOtp() {
      try {
        this.otpLoading = true;
        this.otpError = null;
        this.otpCode = '';

        const response = await this.requestSignatureOtp({ token: this.token });

        if (response.codigo !== 10) {
          this.otpError = (response.errores || []).join('. ') || response.mensaje;
          return;
        }

        this.otpId = response.otpId;
        this.otpSent = true;
        this.startOtpCountdown();

        this.$nextTick(() => {
          if (this.$refs.otpInput) {
            this.$refs.otpInput.focusFirst();
          }
        });

        this.$bvToast.toast(
          'Se ha enviado un código de verificación a tu correo electrónico',
          {
            title: 'Código enviado',
            variant: 'success',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
      } catch (error) {
        console.error(error);
        const msg = error.response && error.response.data
          ? (error.response.data.errores || []).join('. ') || error.response.data.mensaje
          : 'No se pudo enviar el código. Intenta nuevamente.';
        this.otpError = msg;
      } finally {
        this.otpLoading = false;
      }
    },
    resetOtp() {
      this.otpSent = false;
      this.otpCode = '';
      this.otpId = null;
      this.otpCountdown = 0;
      this.otpError = null;
      this.otpLoading = false;
      clearInterval(this.otpTimer);
      this.otpTimer = null;
    },
    async signFileWithOtp() {
      if (!this.otpCode || this.otpCode.length < 6 || this.otpLoading) return;
      try {
        this.otpLoading = true;
        this.otpError = null;

        const response = await this.singPersonFile({
          token: this.token,
          otpId: this.otpId,
          otpCode: this.otpCode
        });

        this.showOtpModal = false;
        this.signatures = [];

        this.$bvToast.toast(
          `${response.mensaje}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        await this.getApprovalFileSignaturePerson({ token: this.token });
        this.selectFile(this.fileOnFlow.documentos[0]);
      } catch (error) {
        console.error(error);
        const msg = error.response && error.response.data
          ? (error.response.data.errores || []).join('. ') || error.response.data.mensaje
          : 'Código incorrecto o expirado. Intenta nuevamente.';
        this.otpError = msg;
      } finally {
        this.otpLoading = false;
      }
    },
    async signFile() {
      // Método legacy mantenido por compatibilidad - el flujo ahora usa signFileWithOtp
      await this.signFileWithOtp();
    }
  },
  async created() {
    try {
      this.$bvToast.toast(
        'Estamos buscando la información necesaria, espera unos segundos',
        {
          title: '¡Hola!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
      const payload = {
        token: this.token
      };
      await this.getApprovalFileSignaturePerson(payload);
      this.selectFile(this.fileOnFlow.documentos[0]);
    } catch (error) {
      console.error(error);
    }
  },
  beforeDestroy() {
    clearInterval(this.otpTimer);
  }
};
</script>

<style lang="scss">

.container-attachment {
  max-height: 55vh;
  overflow-y: scroll;
}
.manage-comments {
  bottom: 60px;
}
.bg-card-grey {
  background-color: #f8f8f8;
  margin-top: 120px;
  min-height: 80%;
  min-width: 85%;
}
</style>
